module.exports = __webpack_public_path__ + "img/stick_hiver_snowpark.0e6343f4.svg";